import { ycrAssetType } from "../../../constant";


const priceReducer = (state = false, action) => {
    switch (action.type) {
        case ycrAssetType.FETCH_INTEREST_RATES_DATA_TYPES_ASSET:
            return action.payload;
        default:
            return state;
    }
}
export default priceReducer